import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { recipientKeys } from '../queries/keys';
import { recipientPaths } from '../queries/paths';

// TSS vite/03 — server-state hooks for parcerías (receptoras del cliente).
// Read-only in Fase 1 (contract: public-client-channel.md). Cache/dedup/retry
// is TanStack Query's job; this module only declares keys + fetchers.
//
// GET public/recipients → { items: [ { id, name, number, farm:{id,name}, status } ],
//                           pagination: { … } }
// The client_id scope comes from the token server-side — never sent from here.

export function useRecipientsList({ limit, offset } = {}) {
    return useQuery({
        queryKey: recipientKeys.list({ limit, offset }),
        queryFn: ({ signal }) =>
            api.get(recipientPaths.list(), { params: { limit, offset }, signal }).then(r => r.data),
        // Keep the current page on screen while the next page loads.
        placeholderData: keepPreviousData,
    });
}
